























































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

import {
  InvestorCompleteInterface,
  SubdocumentsFilesI,
} from "@/types/app/subdocument";
import ModalSuccess from "@/components/common/ModalSuccess.vue";

import Endpoint from "@/utils/endpoint";

import BaseComponent from "@/utils/baseComponent"


type SubscribersInput = {
  email: string;
  slots: Array<number>;
  isValid: boolean;
};

@Component({
  components: { ModalSuccess },
  props: ["showModal", "subdocumentsFiles", "investors", "productId"],
})
export default class ModalDetail extends BaseComponent {

  openSuccessModal = false;
  loading = false;
  valid = false;
  selectedDocument: any = {};
  selectedApprovers = [];
  slots = Array.from(Array(21).keys());
  selectedSlots = [];

  subscribers = [
    {
      email: "#investor#",
      slots: [],
      isValid: true
    },
  ];

  private endpoint = new Endpoint();

  @Prop(String) readonly productId!: any;
  @Prop(Array) readonly investors!: any;
  @Prop(Array) readonly subdocumentsFiles!: SubdocumentsFilesI[];


  addSubscriber() {
    this.subscribers.push({
      email: "",
      slots: [],
      isValid: true
    });
  }

  deleteSubscriber(i: number) {
    if (i == 0)
      return;
    this.subscribers = this.subscribers.filter((sub, index) => index !== i);

  }

  checkEmail(subdoc: SubscribersInput) {

    if (subdoc.email.length > 1 && this.investors.find((x: InvestorCompleteInterface) => x.email == subdoc.email)) {
      this.showError('Email already exists as an investor in subscribers!');
      subdoc.isValid = false;
    }
    else subdoc.isValid = true;
  }

  icon(subscValue: Array<number>) {
    if (this.likesAllSlots(subscValue)) return "mdi-close-box";
    if (this.likesSomeSlots(subscValue)) return "mdi-minus-box";
    return "mdi-checkbox-blank-outline";
  }

  likesAllSlots(selectedSlots: Array<number>) {
    return selectedSlots.length === this.slots.length;
  }

  likesSomeSlots(selectedSlots: Array<number>) {
    return selectedSlots.length > 0 && !this.likesAllSlots(selectedSlots);
  }

  handleWithSelectedSlotsByInput(subsc: SubscribersInput) {
    if (this.likesAllSlots(subsc.slots)) {
      subsc.slots = [];
    } else {
      subsc.slots = this.slots.slice();
    }
  }

 

  async submit() {

    if (!this.form().validate()) {
      return false;
    }
  
     if(this.subscribers.find(x => !x.isValid)){
          this.showError(`Email ${this.subscribers.filter(x => !x.isValid).map(x => x.email).join(',')} already exists as an investor in subscribers!`);
     }

    this.loading = true;
    try {
      const body = {
        userIds: this.investors.map(
          (investor: InvestorCompleteInterface) => investor.userId
        ),
        assigners: this.subscribers,
        approvers: this.selectedApprovers,
        formFieldId: this.investors[0].idFormField,
        productId: this.productId,
        perfilName: 'Default',
        filePath: this.selectedDocument.url,
        fileName: this.selectedDocument.title,
      };

      const response = await this.$http.post(this.endpoint.sendSubdocumentContract, body);
      
      if((response as any)?.hasErrors || (response as any)?.data?.hasErrors)
      {
        this.logHttpError(response);
      }
      else {
        this.closeModal();
        this.showSuccess('Contract send with success!')
      }
    } catch (error) {
      this.logException(error);
    } finally {
      this.loading = false;
    }
  }


  closeModal() {
    this.$emit("close");
    this.form().resetValidation()
    this.selectedApprovers = [];
    this.selectedDocument = {};
    this.subscribers = [
      {
        email: "#investor#",
        slots: [],
        isValid: true
      },
    ];
  }
}
